module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhead1-d01ff274fc8bc0677a37199b567bdb88.jpg";